import { parseTemplate } from 'url-template';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import mapUserProductGroup from './mapUserProductGroup';
import UserProductGroup from './UserProductGroup';

export interface Result {
	productGroup: UserProductGroup;
}

export function createCzReimbursementFromSuklCodes(
	client: ApiClient,
	userId: string,
	name: string | null,
	lists: Array<{ codes: string[] }>
): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/cz-reimbursement-from-sukl-codes');
	const body = { name, lists };

	return client
		.fetch(url.expand({ userId }), {
			method: 'POST',
			body: JSON.stringify(body),
		})
		.then((response) => response.json())
		.then((response) => ({
			productGroup: mapUserProductGroup(response.productGroup),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}
